var productAddonApp = angular.module("productAddon", ["ngRoute", "ngSanitize", "ui.bootstrap", "core"]);

productAddonApp.config(["$locationProvider", "$compileProvider", function ($locationProvider, $compileProvider) {
    $locationProvider.html5Mode(true);
}]);

productAddonApp.controller("ProductAddon", ["$q", "$scope", "$injector", "$window", "product", "translations", "viewsLocation", "AddonProductService", "Inflector", function ($q, $scope, $injector, $window, product, translations, viewsLocation, AddonProductService, Inflector) {
    var self = this;

    self.showModal = function () {
        Notifications.loading(self.translations.loadingAddons);

        getProductsForSteps().then(function () {
            Notifications.closeLoading();
            $("#product-addon-modal").modal();

            initMdbStepper();
        });
    };

    self.getModalTitle = function () {
        if (!_.isUndefined(self.product)) {
            return self.translations.productAddonTitlePrefix + self.product.part_number  + " - " + self.productAddons.addonName;
        }
    };

    self.isActive = function (step) {
        return step.stepCount === 1 ? true : false;
    };

    self.setActive = function (step) {
        self.activeStep = step.stepCount;
    };

    self.getProductImageSrc = function (product) {
        return product.images.small;
    };

    self.getShortDescription = function (product) {
        return product.description;
    };

    self.getPartNumber = function (product) {
        return product.partNum;
    };

    self.getProductsForActiveStep = function () {
        return (!_.isUndefined(self.stepProducts) && !_.isUndefined(self.stepProducts[self.activeStep])) ? self.stepProducts[self.activeStep] : [];
    };

    self.setProductForActiveStep = function (product) {
        self.stepChoices[self.activeStep] = product;
        self.selectedProduct = product;
        self.requiredValidationFailed[self.activeStep] = false;
    };

    self.nextStep = function () {
        step = getStepForValidation();

        isStepValid(step);

        self.stepper.nextStep();
        self.activeStep++;
        self.selectedProduct = [];
    };

    self.previousStep = function () {
        self.stepper.prevStep();
        self.activeStep--;
        self.selectedProduct = [];
    };

    self.completeWizard = function () {
        var step = getStepForValidation();

        isStepValid(step);
    };

    self.resetStepper = function () {
        self.stepper = null;
        initDefaults();
        $("#product-addon-modal").modal("hide");
    };

    self.isSelectedProduct = function (product, step) {
        if (!_.isUndefined(self.stepChoices[step]) && !_.isNull(self.stepChoices[step])) {
            return product.partNum === self.stepChoices[step].partNum ? true : false;
        }
    };

    self.hasAddons = function (slug) {
        if (!_.isEmpty(window.addonResults)) {
            item = getAddonsForItem(slug);
            if (!_.isUndefined(item)) {
                self.product = item;
                self.productAddons = item.addons;

                initDefaults();
            }
        }

        return !_.isEmpty(self.productAddons) && self.productAddons.config.length > 0 ? true : false;
    };

    self.showAlerts = function (step) {
        return step.isMandatory || step.isCommentRequired || step.isDiscountable;
    };

    self.isNotFirstStep = function () {
        return self.activeStep !== 1;
    };

    self.isLastStep = function () {
        if (!_.isUndefined(self.product)) {
            return self.activeStep === self.productAddons.config.length;
        }
    };

    self.isOrderNoteStep = function (step) {
        return !_.isEmpty(step.orderNotes);
    };

    self.dasherise = function (string) {
        return Inflector.dasherise(string);
    };

    self.getNotes = function () {
        return !_.isEmpty(self.orderNotes) ? self.orderNotes : [];
    };

    self.isQuoteOnly = function () {
        return self.product.is_quote_only === true && !self.isAddToCart;
    };

    self.setIsAddToCart = function () {
        self.isAddToCart = true;
    };

    var initMdbStepper = function () {
        var stepperDiv = document.querySelector(".stepper");
        self.stepper = new MStepper(stepperDiv);
    };

    var initDefaults = function () {
        self.activeStep = 1;
        self.stepChoices = {};
        self.selectedProduct = [];
        self.requiredValidationFailed = [];
        self.commentValidationFailed = [];
        self.isAddToCart = false;

        if (!_.isUndefined(self.productAddons)) {
            _.forEach(self.productAddons.config, function (step) {
                self.stepChoices[step.stepCount] = null;
            });
        }
    };

    var getProductsForSteps = function () {
        if (!_.isNull(self.productAddons.id)) {
            return AddonProductService.get(self.productAddons.id).then(
                function (products) {
                    self.stepProducts = products;
                }
            );
        } else {
            return $q(function(resolve) {
                setTimeout(function() {
                    resolve(true);
                }, 1000);
            });
        }
    };

    var getStepForValidation = function () {
        return _.filter(self.productAddons.config, function(step) {
            if (step.stepCount === self.activeStep) {
                return step;
            }
        })[0];
    };

    var isStepValid = function (step) {
        if (step.isMandatory) {
            if (_.isNull(self.stepChoices[step.stepCount])) {
                self.requiredValidationFailed[step.stepCount] = true;
                self.stepper.wrongStep();
                throw new Error("Invalid");
            }
        }

        if (step.isCommentRequired && !_.isNull(self.stepChoices[step.stepCount])) {
            if (_.isUndefined(self.stepChoices[step.stepCount].comment)) {
                self.commentValidationFailed[step.stepCount] = true;
                self.stepper.wrongStep();
                throw new Error("Required");
            }
        }
    };

    var getAddonsForItem = function (slug) {
        return _.filter(window.addonResults, function (item) {
            if (item.slug === slug) {
                return item;
            }
        })[0];
    };

    (function () {
        self.templateLocation = viewsLocation + "/ProductAddons.html";
        self.translations = translations;

        if (!_.isEmpty(product)) {
            self.product = product;
            self.productAddons = product.addons;
            initDefaults();
        }
    })();
}]);

angular.module("productAddon").factory("AddonProductService", ["HttpService", "rootUrl", function (HttpService, rootUrl) {
    return {
        get: function (addonId) {
            return HttpService.get({
                url: rootUrl + "product-addon-products",
                params: {
                    addonId: addonId
                }
            });
        }
    };
}]);
